import { DataBean } from "../DataBean";
export const ESTADO_COMITE = [
    { id: 1, name: "REGISTRADO" },
    { id: 3, name: "COMITE CREDITO" },
    { id: 2, name: "APROBADO" },
    { id: 4, name: "RECHAZADO" },
    { id: 5, name: "APLAZADO" },
    { id: 6, name: "FIRMANDO" },
];
export class CreditAccount extends DataBean {

    public async getRequestCreditRender(page: number | null, rows: number | null, props: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getRequestCreditRender_Number_Number_java.util.Map",
            [page, rows, props]);
    }
    public async generateAmotizationTable(monto: any, tasa: any, cuotas: any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_generateAmotizationTable_Double_Double_Number",
            [monto, tasa, cuotas]);
    }
    public async consolidarCreditos(idEmployee: number, data: string): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_consolidarCreditos_Number_String",
            [idEmployee, data]);
    }
    public async actualizarCartera(idEmployee: number, data: string): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_actualizarCartera_Number_String",
            [idEmployee, data]);
    }
    public async getCoutaCreditoByMonth(idEmployee: number, fechaCuota: any, data: string): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getCoutaCreditoByMonth_Number_java.util.Date_String",
            [idEmployee, fechaCuota, data]);
    }
    public async getComiteCreditoRender(page: number, rows: number, props: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getComiteCreditoRender_Number_Number_java.util.Map",
            [page, rows, props]);
    }
    public async getComiteCreditoValoresRender(page: number, rows: number, props: any, fecha: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getComiteCreditoValoresRender_Number_Number_java.util.Map_java.util.Date",
            [page, rows, props, fecha]);
    }
    public async importarComiteCredito(idEmployee: number, data: any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_importarComiteCredito_Number_String",
            [idEmployee, data]);
    }
    public async crearActaComite(idEmployee: number, jsonFirmas: any, jsonProps: any, approveDate: any, desembolsoDate: any, commiteNumber: string, jsonCodes: string): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_crearActaComite_Number_String_String_java.util.Date_java.util.Date_String_String",
            [idEmployee, jsonFirmas, jsonProps, approveDate, desembolsoDate, commiteNumber, jsonCodes]);
    }
    public async updateCreditCommite(bean: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.credit.bean.CreditCommite_updateCreditCommite_com.credit.bean.CreditCommite",
            [{
                DataBeanProperties: bean,
                DataBeanName: "com.credit.bean.CreditCommite"
            }]);
    }
    public async recrearCreditoByList(idEmployee: number, data: any, listCorreo: any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_recrearCreditoByList_Number_String_java.util.List",
            [idEmployee, data, listCorreo]
        );
    }
    public async recrearCreditoByListSerial(idEmployee: number, data: any, listCorreo: any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_recrearCreditoByListSerial_Number_String_java.util.List",
            [idEmployee, data, listCorreo]
        );
    }
    public async migrateCreditosAffiliado(idCreditAffiliate: number): Promise<any> {
        return this.getCustomService("CreditCore", "void_migrateCreditosAffiliado_Number",
            [idCreditAffiliate]
        );
    }
    public async getCifinReport(idEmployee: number, year: number, month: number, prosp: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getCifinReport_Number_Number_Number_java.util.Map",
            [idEmployee, year, month, prosp]
        );
    }
    public async recrearCreditoFromFile(idEmployee: number, data: any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_recrearCreditoFromFile_Number_String",
            [idEmployee, data]
        );
    }
    public async executeRutine(idEmployee: number, routineName: string, notify: any[]): Promise<any> {
        return this.getCustomService("CreditCore", "void_executeRutine_Number_String_java.util.List",
            [idEmployee, routineName, notify]
        );
    }
    public async executeUpdateNominadora(idEmployee: number, data: string): Promise<any> {
        return this.getCustomService("CreditCore", "void_executeUpdateNominadora_Number_String",
            [idEmployee, data]
        );
    }
    public async createManagedCredit(idEmployee: number, idLoanLine: number, year: number, month: number): Promise<any> {
        return this.getCustomService("CreditCore", "void_createManagedCredit_Number_Number_Number_Number",
            [idEmployee, idLoanLine, year, month]
        );
    }
    public async updateManagedCreditByFile(idEmployee: number, year: number, month: number, data: string): Promise<any> {
        return this.getCustomService("CreditCore", "void_updateManagedCreditByFile_Number_Number_Number_String",
            [idEmployee, year, month, data]
        );
    }
    public async updateValuesOfCreditAccount(idEmployee: number, data: string, year: number, month: number): Promise<any> {
        return this.getCustomService("CreditCore", "void_updateValuesOfCreditAccount_Number_String_Number_Number",
            [idEmployee, data, year, month]
        );
    }
    public async getValueCuoteCredit(totalValue: number, tasa: number, meses: number): Promise<any> {
        return this.getCustomService("CreditCore", "Number_getValueCuoteCredit_Number_Number_Number",
            [totalValue, tasa, meses]
        );
    }
    public async generateAmortizationTable6(totalValue: number, tasaMensual: number, meses: number, cuotaFija: number, fechaDesembolso: any, diaCorte: number): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_generateAmortizationTable_Number_Number_Number_Number_java.util.Date_Number",
            [totalValue, tasaMensual, meses, cuotaFija, fechaDesembolso, diaCorte]
        );
    }

}
